import { CheckCircle } from "lucide-react";
import { Type } from "@shared/ui/Type";
import Button from "@shared/ui/Button";

type Props = {
  handleJoinClick: () => void;
  handleInviteOrg: () => void;
  isLoading: boolean;
  isValid: boolean;
  isNew: boolean;
  label: string;
};
export function OrgLookupItem({
  handleJoinClick,
  handleInviteOrg,
  isLoading,
  isValid,
  isNew,
  label,
}: Props) {
  return (
    <div className="px-4 py-3 gap-4 border-2 border-brand-600 rounded-lg flex flex-row justify-between items-center">
      <div className="flex flex-col gap-1 pl-4">
        <Type variant="h5">{label}</Type>
        <div className="flex items-center">
          {!isNew && (
            <CheckCircle
              size={16}
              strokeWidth={2}
              className="text-success mr-2"
            />
          )}
          <Type variant="caption">
            {isNew
              ? "Not currently in our network. Encourage them to support your free participation in Pollinator."
              : "Participating in Pollinator"}
          </Type>
        </div>
      </div>
      {!isNew && (
        <Button
          variant="primary"
          className="size-max px-2"
          onClick={handleJoinClick}
          disabled={!isValid || isLoading}
          data-testid="org-lookup-join"
        >
          {isLoading && "Validating..."}
          {!isLoading && !isValid && "Unavailable"}
          {!isLoading && isValid && "Join"}
        </Button>
      )}
      {isNew && (
        <Button
          variant="primary"
          className="size-max px-2 w-[190px]"
          onClick={handleInviteOrg}
          data-testid="org-lookup-invite"
        >
          Invite Org
        </Button>
      )}
    </div>
  );
}

export default OrgLookupItem;
